import React from 'react'
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined'
import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined'
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined'
import WarehouseOutlinedIcon from '@mui/icons-material/WarehouseOutlined'
import Navigation, { type NavigationData } from './Navigation'
import { useAppSelector } from '../../../redux/hooks'
import { EnvConfig, EnvType, KaryonModules } from '../../../redux/user/userTypes'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { listOfFSDistributors } from '../../../pages/private/Foodservice/types'
import StarIcon from '@mui/icons-material/Star';
import { Grid } from '@mui/material'
import { PrimaryText } from '../../ui/Text'
import { BLACK } from '../../ui/Colors'
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import { listOfRetailDistributors } from '../../../pages/private/Retail/types'

const KaryonCompanyId = "67603cd7659a5b6f4f542582";

const retailLinks = (distributor: string): NavigationData[] => {
    switch (distributor.toLocaleLowerCase()) {
        case KaryonModules.SELL_IN:
            return [{
                id: 0,
                label: 'Tableau de bord',
                link: `/retail/${distributor}/dashboard`,
                icon: <InsightsOutlinedIcon />,
            },
            {
                id: 1,
                label: 'Commerciaux',
                link: `/food-service/${distributor}/commerciaux`,
                icon: <StoreOutlinedIcon />,
            },
            {
                id: 2,
                label: 'Clients',
                link: `/food-service/${distributor}/clients`,
                icon: <StoreOutlinedIcon />,
            },
            {
                id: 3,
                label: 'Références',
                link: `/food-service/${distributor}/produits`,
                icon: <InventoryOutlinedIcon />,
            },]
        case "parts de marché"://KaryonModules.MARKET_SHARE:
            return [{
                id: 0,
                label: 'Tableau de bord',
                link: `/retail/market-share/dashboard`,
                icon: <InsightsOutlinedIcon />,
            },
            {
                id: 1,
                label: 'Points de vente',
                link: `/retail/market-share/pointsdevente`,
                icon: <StoreOutlinedIcon />,
            },
            {
                id: 2,
                label: 'Fournisseurs',
                link: `/retail/market-share/fournisseurs`,
                icon: <EmojiPeopleIcon />,
            },
            {
                id: 4,
                label: 'Références',
                link: `/retail/market-share/produits`,
                icon: <InventoryOutlinedIcon />,
            },]
        default:
            return [
                {
                    id: 0,
                    label: 'Tableau de bord',
                    link: `/retail/${distributor}/dashboard`,
                    icon: <InsightsOutlinedIcon />,
                },
                {
                    id: 1,
                    label: 'Points de vente',
                    link: `/retail/${distributor}/magasins`,
                    icon: <StoreOutlinedIcon />,
                },
                {
                    id: 2,
                    label: 'Références',
                    link: `/retail/${distributor}/produits`,
                    icon: <InventoryOutlinedIcon />,
                },
            ]
    }
}
const fsLinks = (distributor: string, modules: KaryonModules[], companyModules: KaryonModules[], config: EnvConfig): NavigationData[] => {
    const shouldHavePromoPage = modules.includes(KaryonModules.PROMO) && companyModules.includes(KaryonModules.PROMO)
    const shouldHavePromoDemo = !companyModules.includes(KaryonModules.PROMO)
    const hasSellout = config ? config.sellout !== false ? true : false : true

    switch (distributor) {
        case listOfFSDistributors.FRANCE_FRAIS:
        case listOfFSDistributors.EPISAVEURS:
        case listOfFSDistributors.TRANSGOURMET:
        case listOfFSDistributors.TRANSGOURMETPLUS:
        case listOfFSDistributors.FRANCEBOISSONS:
        case 'Commandes':
            return [
                ...(hasSellout ? [{
                    id: 0,
                    label: 'Tableau de bord',
                    link: `/food-service/${distributor}/dashboard`,
                    icon: <InsightsOutlinedIcon />,
                },
                {
                    id: 1,
                    label: 'Utilisateurs finaux',
                    link: `/food-service/${distributor}/clients`,
                    icon: <StoreOutlinedIcon />,
                },
                {
                    id: 2,
                    label: 'Dépôts',
                    link: `/food-service/${distributor}/depots`,
                    icon: <WarehouseOutlinedIcon />,
                },
                {
                    id: 3,
                    label: 'Références',
                    link: `/food-service/${distributor}/produits`,
                    icon: <InventoryOutlinedIcon />,
                }] : []),
                ...(shouldHavePromoPage
                    ? [
                        {
                            id: 4,
                            label: 'Promo',
                            link: `/food-service/${distributor}/promo`,
                            icon: <AttachMoneyIcon />,
                        },
                    ]
                    : []),
                ...(shouldHavePromoDemo ? [{
                    id: 4,
                    label: <Grid container alignItems="center" justifyContent="space-between"><PrimaryText color={BLACK} noWrap style={{ cursor: "pointer" }}>Promo</PrimaryText><StarIcon sx={{ color: "#FFD233", fontSize: "2vmin" }} /></Grid>,
                    link: `/food-service/${distributor}/promoDemo`,
                    icon: <AttachMoneyIcon />,

                }] : [])
            ]

        case listOfFSDistributors.SODEXO:
        case listOfFSDistributors.CERCLEVERT:
            return [
                ...(hasSellout ? [{
                    id: 0,
                    label: 'Tableau de bord',
                    link: `/food-service/${distributor}/dashboard`,
                    icon: <InsightsOutlinedIcon />,
                },
                {
                    id: 1,
                    label: 'Utilisateurs finaux',
                    link: `/food-service/${distributor}/clients`,
                    icon: <StoreOutlinedIcon />,
                },
                {
                    id: 2,
                    label: 'Références',
                    link: `/food-service/${distributor}/produits`,
                    icon: <InventoryOutlinedIcon />,
                }] : []),
                ...(shouldHavePromoDemo ? [{
                    id: 4,
                    label: <Grid container alignItems="center" justifyContent="space-between"><PrimaryText color={BLACK} noWrap style={{ cursor: "pointer" }}>Promo</PrimaryText><StarIcon sx={{ color: "#FFD233", fontSize: "2vmin" }} /></Grid>,
                    link: `/food-service/${distributor}/promoDemo`,
                    icon: <AttachMoneyIcon />,

                }] : [])
            ]
        case listOfFSDistributors.C10:
        case listOfFSDistributors.DISTRIBOISSONS:
            return [
                ...(hasSellout ? [{
                    id: 0,
                    label: 'Tableau de bord',
                    link: `/food-service/${distributor}/dashboard`,
                    icon: <InsightsOutlinedIcon />,
                },
                {
                    id: 1,
                    label: 'Dépôts',
                    link: `/food-service/${distributor}/depots`,
                    icon: <WarehouseOutlinedIcon />,
                },
                {
                    id: 2,
                    label: 'Références',
                    link: `/food-service/${distributor}/produits`,
                    icon: <InventoryOutlinedIcon />,
                }] : []),
                ...(shouldHavePromoDemo ? [{
                    id: 4,
                    label: <Grid container alignItems="center" justifyContent="space-between"><PrimaryText color={BLACK} noWrap style={{ cursor: "pointer" }}>Promo</PrimaryText><StarIcon sx={{ color: "#FFD233", fontSize: "2vmin" }} /></Grid>,
                    link: `/food-service/${distributor}/promoDemo`,
                    icon: <AttachMoneyIcon />,

                }] : [])]
        case listOfFSDistributors.GBH:
            return [
                ...(hasSellout ? [{
                    id: 0,
                    label: 'Tableau de bord',
                    link: `/food-service/${distributor}/dashboard`,
                    icon: <InsightsOutlinedIcon />,
                },
                {
                    id: 1,
                    label: 'Points de vente',
                    link: `/food-service/${distributor}/pointsdevente`,
                    icon: <StoreOutlinedIcon />,
                },
                {
                    id: 2,
                    label: 'Concurrents',
                    link: `/food-service/${distributor}/concurrents`,
                    icon: <EmojiPeopleIcon />,
                },
                {
                    id: 4,
                    label: 'Références',
                    link: `/food-service/${distributor}/produits`,
                    icon: <InventoryOutlinedIcon />,
                }] : []),
                ...(shouldHavePromoDemo ? [{
                    id: 4,
                    label: <Grid container alignItems="center" justifyContent="space-between"><PrimaryText color={BLACK} noWrap style={{ cursor: "pointer" }}>Promo</PrimaryText><StarIcon sx={{ color: "#FFD233", fontSize: "2vmin" }} /></Grid>,
                    link: `/food-service/${distributor}/promoDemo`,
                    icon: <AttachMoneyIcon />,

                }] : [])
            ]
        case listOfFSDistributors.CERCLEVERTPDM:
            return [
                ...(hasSellout ? [{
                    id: 0,
                    label: 'Tableau de bord',
                    link: `/food-service/${distributor}/dashboard`,
                    icon: <InsightsOutlinedIcon />,
                },
                {
                    id: 2,
                    label: 'Concurrents',
                    link: `/food-service/${distributor}/concurrents`,
                    icon: <EmojiPeopleIcon />,
                },
                {
                    id: 4,
                    label: 'Références',
                    link: `/food-service/${distributor}/produits`,
                    icon: <InventoryOutlinedIcon />,
                }] : []),
                ...(shouldHavePromoDemo ? [{
                    id: 4,
                    label: <Grid container alignItems="center" justifyContent="space-between"><PrimaryText color={BLACK} noWrap style={{ cursor: "pointer" }}>Promo</PrimaryText><StarIcon sx={{ color: "#FFD233", fontSize: "2vmin" }} /></Grid>,
                    link: `/food-service/${distributor}/promoDemo`,
                    icon: <AttachMoneyIcon />,

                }] : [])
            ]
        default:
            return [
                ...(hasSellout ? [{
                    id: 0,
                    label: 'Tableau de bord',
                    link: `/food-service/${distributor}/dashboard`,
                    icon: <InsightsOutlinedIcon />,
                },
                {
                    id: 1,
                    label: 'Utilisateurs finaux',
                    link: `/food-service/${distributor}/clients`,
                    icon: <StoreOutlinedIcon />,
                },
                {
                    id: 2,
                    label: 'Dépôts',
                    link: `/food-service/${distributor}/depots`,
                    icon: <WarehouseOutlinedIcon />,
                },
                {
                    id: 3,
                    label: 'Références',
                    link: `/food-service/${distributor}/produits`,
                    icon: <InventoryOutlinedIcon />,
                }] : []),
                ...(shouldHavePromoPage
                    ? [
                        {
                            id: 4,
                            label: 'Promo',
                            link: `/food-service/${distributor}/promo`,
                            icon: <AttachMoneyIcon />,
                        },
                    ]
                    : []),
                ...(shouldHavePromoDemo ? [{
                    id: 4,
                    label: 'Promo',
                    link: `/food-service/${distributor}/promoDemo`,
                    icon: <AttachMoneyIcon />,
                }] : [])
            ]
    }
}

const crossFsLinks = (url: string): NavigationData[] => [
    {
        id: 0,
        label: 'Tableau de bord',
        link: `/food-service/cross/dashboard`,
        icon: <InsightsOutlinedIcon />,
    },
    ...url.includes('alpha') ? [{
        id: 1,
        label: 'Distributeurs',
        link: `/food-service/cross/distributeurs`,
        icon: <HubOutlinedIcon />,
    },
    {
        id: 2,
        label: 'Dépôts',
        link: `/food-service/cross/depots`,
        icon: <WarehouseOutlinedIcon />,
    },
    {
        id: 1,
        label: 'Utilisateurs finaux',
        link: `/food-service/cross/clients`,
        icon: <StoreOutlinedIcon />,
    },
    {
        id: 3,
        label: 'Références',
        link: `/food-service/cross/produits`,
        icon: <InventoryOutlinedIcon />,
    }] : [],
]

const superAdmin = (companyId): NavigationData[] => [
    {
        id: 0,
        label: 'Accueil',
        link: `/multiAccount`,
        icon: <HomeOutlinedIcon />,
    },
    ...companyId === KaryonCompanyId ? [{
        id: 0,
        label: 'Ajouter un article',
        link: `/multiAccount/addArticle`,
        icon: <LiveHelpIcon />,
    }] : [],
    ...companyId === KaryonCompanyId ? [{
        id: 0,
        label: 'Modifier/supprimer un article',
        link: `/multiAccount/editAndDeleteArticle`,
        icon: <LiveHelpIcon />,
    }] : []
]


const crossRetailLinks = (): NavigationData[] => [
    {
        id: 0,
        label: 'Tableau de bord',
        link: `/retail/cross/dashboard`,
        icon: <InsightsOutlinedIcon />,
    },
    {
        id: 1,
        label: 'Distributeurs',
        link: `/retail/cross/distributeurs`,
        icon: <HubOutlinedIcon />,
    },
    {
        id: 2,
        label: 'Points de vente',
        link: `/retail/cross/magasins`,
        icon: <StoreOutlinedIcon />,
    },
    {
        id: 3,
        label: 'Références',
        link: `/retail/cross/produits`,
        icon: <InventoryOutlinedIcon />,
    },
]

const Navbar = () => {
    const { type, name, config } = useAppSelector((state) => state.global.env)
    const { user } = useAppSelector((state) => state.user)

    switch (type) {
        case EnvType.FOOD_SERVICE:
            return (
                <Navigation
                    data={fsLinks(
                        name,
                        user.modules, user.companyModules,
                        config)
                    }
                />
            )
        case EnvType.FOOD_SERVICE_CROSS:
            return <Navigation data={crossFsLinks(window.location.href)} />
        case EnvType.RETAIL_CROSS:
            return <Navigation data={crossRetailLinks()} />
        case EnvType.RETAIl:
            return <Navigation data={retailLinks(name)} />
        case EnvType.SUPER_ADMIN:
            return <Navigation data={superAdmin(user.companyId)} />
        default:
            return <></>
    }
}

export default Navbar
